@if (activeMedia) {
  <div class="active-media" [ngClass]="{'active-media--draggable': zoomValue > 1}">
    <div class="active-media__container">
      @if (objectType === 'Model3D') {
        <div class="model-3d-placeholder">
          <i class="icon-object"></i>
        </div>
      } @else if (validThumbnailSrc && !playMedia) {
        <img
          [src]="imageUrl"
          [alt]="'TRANS__ACTIVE_MEDIA__ACTIVE_MEDIA' | translate"
          id="mediaItem-{{activeMedia.artifact_id}}"
          (error)="setDefaultImg()"
        >
        @if (isPlayable) {
          <a (click)="onPlayMedia()" class="playButton">
            <i class="icon-play2"></i>
          </a>
        }
      } @else if (isPlayable && playMedia) {
        <div
          class="active-media__player-container"
          [class.active-media__player-container--video]="objectType === 'Video' && !showWaveformPlayer"
        >
          @if (showWaveformPlayer) {
            <app-audio-waveform-player
              [playbackUrl]="waveformPlaybackUrl"
              [regions]="segmentRegions"
              [compact]="true"
              [activeRegionId]="activeRegionId"
              [limitPlaybackToActiveRegion]="true"
              [showVideo]="objectType === 'Video'"
            />
          } @else if (objectType === 'Video' && activeMedia?.dms_identifier; as dmsId) {
            <app-dms-video-player
              [dmsApi]="dmsApiUrl"
              [dmsIds]="dmsId"
              [autoplay]="true"
            />
          }
        </div>
      } @else {
        <div class="default-image">
          @if (objectType === 'Attachment') {
            <i class="icon-image-attention"></i>
            <span>{{ 'TRANS__ACTIVE_MEDIA__NO_ATTACHMENT_IMAGE' | translate }}</span>
          } @else if (uploadStatus !== 'done') {
            <i class="icon-hour-glass"></i>
            <span>{{ 'TRANS__ACTIVE_MEDIA__MEDIA_NOT_READY' | translate }}</span>
          }
        </div>
      }
    </div>
  </div>
}
